/**
 * count number of newsletter blocks inside page content
 * showGlobalFallback resolves true if no other newsletter block rendered
 */
export const useNewsletterBlocksStore = defineStore('newsletterBlocks', {
  state: () => ({
    count: 0,
  }),

  getters: {
    showGlobalFallback: (state) => {
      return state.count === 0;
    },
  },

  actions: {
    increment() {
      this.count = this.count + 1;
    },

    reset() {
      this.count = 0;
    },
  },
});
